import { FrameDTO } from '@/features/demo/dto/FrameDTO';
import { TranslationsMap } from '@/common/helpers/applyTranslations';

export enum PositionType {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  LEFT_TOP = 'LEFT_TOP',
  LEFT_BOTTOM = 'LEFT_BOTTOM',
  RIGHT_TOP = 'RIGHT_TOP',
  RIGHT_BOTTOM = 'RIGHT_BOTTOM'
}

export enum FrameTooltipType {
  HOTSPOT = 'HOTSPOT',
  TOOLTIP = 'TOOLTIP'
}

export enum NextStepButtonType {
  ELEMENT = 'ELEMENT',
  BUTTON = 'BUTTON'
}

export enum TooltipTargetType {
  CIRCLE = 'circle',
  AREA = 'area'
}

export enum HotspotButtonAction {
  NONE = 'NONE',
  GUIDE = 'GUIDE',
  URL = 'URL'
}

export type HotspotBeaconStyle = 'ring' | 'filled';

export const DEFAULT_HOTSPOT_TOOLTIP_WIDTH = 300;
export const DEFAULT_HOTSPOT_BEACON_SIZE = 20;
export const DEFAULT_HOTSPOT_BEACON_STYLE: HotspotBeaconStyle = 'ring';

/**
 * Extra configuration used only by standalone hotspot campaigns. Lives in a
 * single jsonb column so the frame_tooltip table, shared by demos/guides/
 * sandbox/rpa, does not grow a column per hotspot-only field.
 */
export interface HotspotConfig {
  beaconSize?: number;
  beaconStyle?: HotspotBeaconStyle;
  customSize?: boolean;
  button?: {
    enabled?: boolean;
    text?: string;
    action?: HotspotButtonAction;
    targetId?: string;
  };
}

export interface FrameTooltipDTO {
  id: string;
  hasTitle: boolean;
  titleSize: number;
  title?: string;
  hasDescription: boolean;
  description?: string | null;
  backgroundColor: string;
  textColor?: string;
  width: number;
  height: number;
  frame: FrameDTO;
  frameId: string;
  order: number;
  deleted?: boolean;
  type: FrameTooltipType;
  borderColor?: string;
  x?: number;
  y?: number;
  targetX?: number;
  targetY?: number;
  targetType?: TooltipTargetType;
  targetRect?: { x: number; y: number; width: number; height: number };
  borderRadius?: number;
  borderWidth?: number;
  highlight?: boolean;
  highlightColor?: string;
  positionType?: PositionType;
  hideTargetAfterAnimation?: boolean;
  hasNextButton?: boolean;
  hasPreviousButton?: boolean;
  nextButtonColor?: string;
  nextButtonTextColor?: string;
  previousButtonColor?: string;
  counterColor?: string;
  buttonBorderRadius?: number;
  show?: boolean;
  isBottomFixed: boolean;
  paths?: any[];
  customPath?: string;
  hotspotConfig?: HotspotConfig;
  nextStepButtonType?: NextStepButtonType;
  dimBackground?: boolean;
  targetOutsideOverlay?: boolean;
  /**
   * Per-language overrides ({ [language]: { title, description, ... } }), as sent
   * by the backend in the view payload. Consumed by overlayEntity/usePreviewOverlay
   * so the search bar matches the text the viewer actually sees in the active language.
   */
  translations?: TranslationsMap;
}
